import { useEffect, useState } from 'react';
import Slider from 'react-slick';
import Image from 'next/image';

import XIcon from '../Icons/X';

import './styles.css';

import { TeamMemberInfo } from '.';
import ChevronLeftIcon from '../Icons/ChevronLeft';
import ChevronRightIcon from '../Icons/ChevronRight';

const settings = {
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
};

type Props = {
  handleClose: () => void;
  selectedMemberIndex?: number;
  teamMembers: TeamMemberInfo[];
};

export default function TeamListDialog({
  handleClose,
  selectedMemberIndex,
  teamMembers,
}: Props) {
  const [sliderRef, setSliderRef] = useState<Slider | null>(null);

  useEffect(() => {
    if (sliderRef && selectedMemberIndex) {
      sliderRef.slickGoTo(selectedMemberIndex, true);
    }
  }, [sliderRef]);

  return (
    <div
      role="dialog"
      className=" fixed left-0 right-0 bottom-0 w-full max-w-none h-full min-h-full bg-[rgba(0,0,0,0.8)] z-[100] p-4">
      <div className="h-full flex flex-col flex-wrap items-center justify-center">
        <div className="relative w-full tablet:w-[90%] lg:w-fit max-w-[850px] h-[50%] tablet:h-full tablet:max-h-[425px]">
          <div
            onClick={handleClose}
            aria-label="Close modal"
            className="absolute mt-2 right-[20px] tablet:mt-[-10px] tablet:right-[-10px] w-10 h-[40px] leading-[40px] bg-white text-center rounded-full cursor-pointer shadow-[0_10px_20px_0_rgba(0,0,0,0.1)] z-10 flex items-center justify-center">
            <XIcon className="fill-current w-8 h-8 text-gray-500" />
          </div>
          <button
            onClick={sliderRef?.slickPrev}
            className="hidden lg:block absolute top-[50%] cursor-pointer left-[-70px] translate-y-[-50%] outline-none z-10">
            <ChevronLeftIcon className="w-20 h-20 text-white" />
          </button>
          <button
            onClick={sliderRef?.slickNext}
            className="hidden lg:block absolute top-[50%] cursor-pointer right-[-70px] translate-y-[-50%] outline-none z-10">
            <ChevronRightIcon className="w-20 h-20 text-white" />
          </button>
          <Slider
            ref={setSliderRef}
            className="dialog-carousel max-w-[850px] tablet:max-h-[425px] top-[50%] translate-y-[-50%] h-full"
            {...settings}>
            {teamMembers.map((member, index) => (
              <div key={index} className="!flex flex-wrap relative">
                <div className="hidden tablet:block w-1/2 flex-[0_0_auto]">
                  <div className="h-full min-h-[425px] overflow-hidden relative">
                    <Image
                      src={member.srcSet}
                      alt={`${member.name} - ${member.position}`}
                      fill
                      className="h-full left-0 right-0 bottom-0 object-cover absolute top-0 w-full align-middle max-w-full m-auto"
                      sizes="(min-width: 1280px) 80vw, (min-width: 767px) 90vw, (min-width: 480px) 100vw, 100vw"
                      style={{
                        objectFit: 'cover',
                      }}
                    />
                  </div>
                </div>
                <div className="flex-[0_0_auto] w-full tablet:w-1/2">
                  <div className="max-h-[425px] overflow-auto p-4">
                    <h4 className=" font-semibold text-xl mb-2">
                      {member.name}
                    </h4>
                    <span>{member.position}</span>
                    <p className="mb-4 mt-8 text-gray-700">
                      {member.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
}
